import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
export function Communities() {
  const communities = [{
    name: 'Gilbert',
    image: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?q=80&w=800&auto=format&fit=crop'
  }, {
    name: 'Scottsdale',
    image: 'https://cdn.magicpatterns.com/uploads/hHLYthvNr4vnPP7rS6nMxs/arizona_real_estate_image.png'
  }, {
    name: 'Chandler',
    image: 'https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?q=80&w=800&auto=format&fit=crop'
  }, {
    name: 'Mesa',
    image: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?q=80&w=800&auto=format&fit=crop'
  }, {
    name: 'Tempe',
    image: 'https://images.unsplash.com/photo-1449844908441-8829872d2607?q=80&w=800&auto=format&fit=crop'
  }, {
    name: 'Queen Creek',
    image: 'https://images.unsplash.com/photo-1592595896551-12b371d546d5?q=80&w=800&auto=format&fit=crop'
  }, {
    name: 'San Tan Valley',
    image: 'https://images.unsplash.com/photo-1480074568708-e7b720bb3f09?q=80&w=800&auto=format&fit=crop'
  }, {
    name: 'Gold Canyon',
    image: 'https://images.unsplash.com/photo-1472224371017-08207f84aaae?q=80&w=800&auto=format&fit=crop'
  }];
  return <div id="communities" className="relative py-24 bg-brand-dark overflow-hidden" data-id="element-32">
      {/* Parallax Background */}
      <div className="absolute inset-0 bg-desert-pattern bg-cover bg-center bg-fixed opacity-20" data-id="element-33" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8" data-id="element-34">
        <div className="text-center mb-16" data-id="element-35">
          <h4 className="text-brand-gold font-bold uppercase tracking-widest text-sm mb-2" data-id="element-36">
            Areas Served
          </h4>
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-37">
            Featured Communities
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-38">
          {communities.map((place, index) => <motion.div key={place.name} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.05
        }} className="group relative h-64 overflow-hidden cursor-pointer" data-id="element-39">
              <img src={place.image} alt={`${place.name} Real Estate`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-40" />
              <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors duration-300" data-id="element-41" />
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-42">
                <h3 className="text-white text-2xl font-bold font-heading tracking-wider uppercase border-b-2 border-transparent group-hover:border-brand-gold transition-all pb-1" data-id="element-43">
                  {place.name}
                </h3>
              </div>
            </motion.div>)}
        </div>
      </div>
    </div>;
}